// Window features
furbo.window={};
furbo.window.scroll=function(){
  var scrollId=window.setInterval(function(){
    if(document.body.scrollTop>=550){
      window.clearInterval(scrollId);
    }else{
      document.body.scrollTop+=10;
    }
  }, 1);
};
// Slideshow features
furbo.slideshow={};
furbo.slideshow.index=2;
furbo.slideshow.urls=[
  "//cdn.shopify.com/s/files/1/1907/4499/t/42/assets/furbo-banner-desktop.jpg?v=17553003904952661671646726765",
  "//cdn.shopify.com/s/files/1/1907/4499/t/42/assets/furbo-banner-mobile.jpg?v=98969659591753191021646726769",
  "//cdn.shopify.com/s/files/1/1907/4499/t/42/assets/furbo-banner-desktop-21.jpg?v=163126056543200694321646726764",
  "//cdn.shopify.com/s/files/1/1907/4499/t/42/assets/furbo-banner-mobile-21.jpg?v=164251821963624106931646726767",
  "//cdn.shopify.com/s/files/1/1907/4499/t/42/assets/furbo-banner-desktop-2.jpg?v=127197751985970955391646726763",
  "//cdn.shopify.com/s/files/1/1907/4499/t/42/assets/furbo-banner-mobile-2.jpg?v=15283589143745354831646726767",
  "//cdn.shopify.com/s/files/1/1907/4499/t/42/assets/furbo-banner-desktop-3.jpg?v=77160416132387901061646726764",
  "//cdn.shopify.com/s/files/1/1907/4499/t/42/assets/furbo-banner-mobile-3.jpg?v=63680587896777397451646726768",
  "https://cdn.shopify.com/s/files/1/1885/2557/files/christmas_kv-uk_c357f390-a32c-44cb-8fd3-03521ba278fe.jpg?16005637011953997430",
  "https://cdn.shopify.com/s/files/1/1885/2557/files/christmas_mobile_kv_uk_0c2cd1b7-a553-46ca-a231-d8a52581f744.jpg?16005637011953997430"
];
furbo.slideshow.resize=function(){
  var url;
  if(window.innerWidth>800){
     url=furbo.slideshow.urls[furbo.slideshow.index];
     // url="https://cdn.shopify.com/s/files/1/1362/5949/files/EvergreenKV-Gobi-Desktop_cc9160d4-472f-4b66-acbe-165fc501b605.jpg?13211558108811673844";
    //url="https://cdn.shopify.com/s/files/1/1885/2557/files/christmas_kv-uk.jpg?9718127993010804443";
  }else{
     url=furbo.slideshow.urls[furbo.slideshow.index+1];
     //url="https://cdn.shopify.com/s/files/1/1362/5949/files/EvergreenKV-Gobi-Mobile_91ddcaf2-b194-4217-8695-e0a051dbb52f.jpg?13211558108811673844";
    //url="https://cdn.shopify.com/s/files/1/1885/2557/files/christmas_mobile_kv_uk.jpg?9718127993010804443";
        
  }
  document.getElementById("welcome").style.backgroundImage="url("+url+")";
};
furbo.slideshow.setup=function(){
  var url;
  var preloadUrl;
  var index=furbo.slideshow.index;
  //if(window.screen.width>800){
  if(window.innerWidth>800){
     url=furbo.slideshow.urls[index];
    // url = "https://cdn.shopify.com/s/files/1/1362/5949/files/EvergreenKV-Gobi-Desktop_cc9160d4-472f-4b66-acbe-165fc501b605.jpg?13211558108811673844";
    //url = "https://cdn.shopify.com/s/files/1/1885/2557/files/christmas_kv-uk.jpg?9718127993010804443";
    preloadUrl=furbo.slideshow.urls[index+1];
    //preloadUrl="https://cdn.shopify.com/s/files/1/1885/2557/files/christmas_kv-uk.jpg?9718127993010804443";
  }else{
     url=furbo.slideshow.urls[index+1];
    //url = "https://cdn.shopify.com/s/files/1/1362/5949/files/EvergreenKV-Gobi-Mobile_91ddcaf2-b194-4217-8695-e0a051dbb52f.jpg?13211558108811673844";
    //url = "https://cdn.shopify.com/s/files/1/1885/2557/files/christmas_mobile_kv_uk.jpg?9718127993010804443";
    //preloadUrl="https://cdn.shopify.com/s/files/1/1885/2557/files/christmas_mobile_kv_uk.jpg?9718127993010804443";
    preloadUrl=furbo.slideshow.urls[index];
  }
  var img=new Image();
  img.src=url;
  img.onload=furbo.slideshow.hideLoading;
  // preload another image
  img=new Image();
  img.src=preloadUrl;
};
furbo.slideshow.hideLoading=function(src){
  document.getElementById("welcome-loading").style.display="none";
  var welcome=document.getElementById("welcome");
  welcome.style.backgroundImage="url("+this.src+")";
  welcome.style.textAlign="left";
  document.getElementById("welcome-text").classList.remove("hide");
  // tracking time
  furbo.ga.keyvisual.report();
};
// Features feature
furbo.feature={};
furbo.feature.switchImg=function(featureId, switchId){
  // hide all
  for(var i=0;i<2;i++){
    document.getElementById("feature-"+featureId+"-img-"+i).style.display="none";
    document.getElementById("feature-"+featureId+"-icon-"+i).style.display="inline";
    document.getElementById("feature-"+featureId+"-icon-"+i+"-hover").style.display="none";
  }
  // show target
  document.getElementById("feature-"+featureId+"-img-"+switchId).style.display="block";
  document.getElementById("feature-"+featureId+"-icon-"+switchId).style.display="none";
  document.getElementById("feature-"+featureId+"-icon-"+switchId+"-hover").style.display="inline";
};
// Review feature
furbo.review={};
furbo.review.scrollId;
furbo.review.scroll=function(args){
  window.clearInterval(furbo.review.scrollId);
  var list=document.getElementById("review-items");
  var offset=args.offset;
  var amount=args.amount?args.amount:Math.round(list.offsetWidth/2);
  if(amount<300){
    amount=300;
  }
  var speed=args.speed;
  furbo.review.scrollId=window.setInterval(function(){
    list.scrollLeft+=offset;
    amount-=Math.abs(offset);
    if(amount<=0){
      window.clearInterval(furbo.review.scrollId);
    }
  }, speed);
};
// Instagram feature
furbo.instagram={};
/*
furbo.instagram.accessToken="1916081799.7a7d129.6bd9fa2ae0594d55a5d10152235660ad";
furbo.instagram.getData=function(){
  (function(d, s, id){
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {return;}
    js = d.createElement(s); js.id = id;
    js.src = "https://api.instagram.com/v1/users/self/media/recent/?access_token="+encodeURIComponent(furbo.instagram.accessToken)+"&count=10&callback=furbo.instagram.dataCallback";
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'instagram-api'));
};
furbo.instagram.dataCallback=function(response){
  var items=document.getElementById("instagram-items");
  for(var i=0;i<response.data.length;i++){
    items.innerHTML+="<div class='item' onclick='furbo.instagram.show(this, \""+response.data[i].link+"\");' style='background-image:url(//cdn.shopify.com/s/files/1/1907/4499/t/42/assets/furbo-instagram.png?v=111498420243534068061646726776),url("+response.data[i].images.thumbnail.url+")'></div>";
  }
};
furbo.instagram.show=function(item, url){
  // Show media loading
  //document.getElementById("media-loading").style.display="block";
  // Call instagram API
  var js=document.getElementById("instagram-api");
  if(js){js.parentNode.removeChild(js);}
  // Add script to call api
  (function(d, s, id){
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) {return;}
    js = d.createElement(s); js.id = id;
    js.src = "https://api.instagram.com/oembed?url="+encodeURIComponent(url)+"&omitscript=false&maxwidth=500&callback=furbo.instagram.showCallback";
    fjs.parentNode.insertBefore(js, fjs);
  }(document, 'script', 'instagram-api'));
  // Scroll items
  var list=document.getElementById("instagram-items");
  var offset=(item.offsetLeft+item.offsetWidth/2)-(list.scrollLeft+list.offsetWidth/2);
  if(offset!=0){
    furbo.instagram.scroll({
      amount:Math.abs(offset),
      offset:2*offset/Math.abs(offset),
      speed:1
    });
  }
};
furbo.instagram.showCallback=function(response){
  // Show item
  furbo.popup.showInstagram(response.html);
  instgrm.Embeds.process();
};
furbo.instagram.scrollId;
furbo.instagram.scroll=function(args){
  window.clearInterval(furbo.instagram.scrollId);
  var list=document.getElementById("instagram-items");
  var offset=args.offset;
  var amount=args.amount?args.amount:Math.round(list.offsetWidth/2);
  var speed=args.speed;
  furbo.instagram.scrollId=window.setInterval(function(){
    list.scrollLeft+=offset;
    amount-=Math.abs(offset);
    if(amount<=0){
      window.clearInterval(furbo.instagram.scrollId);
    }
  }, speed);
};
// furbo.instagram.getData();
*/
// Popup media feature
furbo.popup={};
furbo.popup.showVideo=function(code, gaEvents){
  var mask=document.getElementById("media-mask");
  mask.style.display="block";
  var content=document.getElementById("media-content");
  content.innerHTML=code;
  content.style.display="block";
  document.getElementById("media-close").style.display="block";
  furbo.popup.resize();
};
furbo.popup.showInstagram=function(code){
  var mask=document.getElementById("media-mask");
  var content=document.getElementById("media-content");
  var close=document.getElementById("media-close");
  content.innerHTML=code;
  window.setTimeout(function(){
    mask.style.display="block";
    close.style.display="block";
    content.style.display="block";
    // Hide media loading
    //document.getElementById("media-loading").style.display="none";
  }, 500);
  furbo.popup.resize();
};
furbo.popup.resize=function(){
  var content=document.getElementById("media-content");
  if(content.style.display=="block"){
    var width=content.offsetWidth*0.8>1280?1280:content.offsetWidth*0.8;
    var height=720*width/1280;
    content.firstChild.width=width;
    content.firstChild.height=height;
  }
};
furbo.popup.hide=function(){
  document.getElementById("media-mask").style.display="none";
  document.getElementById("media-close").style.display="none";
  var content=document.getElementById("media-content");
  content.style.display="none";
  content.innerHTML="";
};
// Initialize
// window.addEventListener("resize", furbo.slideshow.resize);
window.addEventListener("load", function(){
  document.getElementById("media-content").addEventListener("click", furbo.popup.hide);
  document.getElementById("media-close").addEventListener("click", furbo.popup.hide);
});
// Initialize Scroll Tracking
furbo.ga.scroll.setup(furbo.ga.events.category.HOMEPAGE);

// added count down js 20171129, Ken
//Furbo countdown function
/*
var countDownDate = new Date(2018,05-1,14,00,00);
// Update the count down every 1 second
var x = setInterval(function() {

  // Get todays date and time
  var now = new Date().getTime();

  // Find the distance between now an the count down date
  var distance = countDownDate - now;

  // Time calculations for days, hours, minutes and seconds
  var days = Math.floor(distance / (1000 * 60 * 60 * 24));
  var hours = Math.floor((distance % (1000 * 60 * 60 * 24 )) / (1000 * 60 * 60));
  var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = Math.floor((distance % (1000 * 60)) / 1000);

  // Display the result in the element with id="demo"
  if(window.innerWidth>800){
  document.getElementById("CountDown-pc").innerHTML =  "<table align=\"left\"><tr align=\"center\"><td><span style=\"font-size:32px;color:#ffd300\">"
  + days + ":</span><br><span style=\"font-size:12px\">DAYS</span></td><td><span style=\"font-size:32px;color:#ffd300\">"
  + hours + ":</span><br><span style=\"font-size:12px\">HOURS</span></td><td><span style=\"font-size:32px;color:#ffd300\">"
  + minutes + ":</span><br><span style=\"font-size:12px\">MINS</span></td><td><span style=\"font-size:32px;color:#ffd300\">"
  + seconds + "</span><br><span style=\"font-size:12px\">SECS</span></td></tr></table>";
    }
  else
  {
  document.getElementById("CountDown-mobile").innerHTML =  "<table align=\"center\"><tr align=\"center\"><td><span style=\"font-size:24px;color:#ffd300\">"
  + days + "</span><span style=\"font-size:14px\">DAYS&nbsp;</span></td><td><span style=\"font-size:24px;color:#ffd300\">"
  + hours + "</span><span style=\"font-size:14px\">HOURS&nbsp;</span></td><td><span style=\"font-size:24px;color:#ffd300\">"
  + minutes + "</span><span style=\"font-size:14px\">MINS&nbsp;</span></td><td><span style=\"font-size:24px;color:#ffd300\">"
  + seconds + "</span><span style=\"font-size:14px\">SECS&nbsp;</span></td></tr></table>";    
  }
  // If the count down is finished, write some text 
  if (distance < 0) {
    clearInterval(x);
    document.getElementById("CountDown").innerHTML = "-";
  }
}, 1000);
*/
var currentStoryIndex = 0;

furbo.saveDogLives = {};
furbo.saveDogLives.showMask = function(index) {
  document.getElementById(`mask${index}`).style.display = 'block';
};
furbo.saveDogLives.hideMask = function(index) {
  document.getElementById(`mask${index}`).style.display = 'none';
};
furbo.saveDogLives.goToPage = function() {
  window.location.href = '/pages/save-dog-lives';
};
furbo.saveDogLives.switchStory = function(index) {
  const stories = document.getElementsByClassName('mySlides');
  stories[currentStoryIndex].style.display = 'none';
  if (index > 0 && currentStoryIndex > 1) {
    currentStoryIndex = 0;
  } else if (index < 0 && currentStoryIndex < 1) {
    currentStoryIndex = 2;
  } else {
    currentStoryIndex += index;
  }
  stories[currentStoryIndex].style.display = 'block';
};